import * as Effects from 'redux-saga/effects'
import { notInRemovedAndRemovedRooms } from '../../reducers/bookingCalendar/selectors/events'
import { ClientActions } from '../../reducers/clients/actionNames'
import { getClientsList } from '../../reducers/clients/selectors'
import { toColor } from '../../utils/ColorTransformator'

function* openInfoModal(action) {
  const clients = yield Effects.select(getClientsList)
  const client = clients.find(c => c.id === action.id)
  const events = yield Effects.select(notInRemovedAndRemovedRooms)

  const reservations = events.filter(
    e =>
      e.guest &&
      e.guest.name === client.name &&
      e.guest.email === client.email &&
      e.guest.phone === client.phone,
  )

  // reservations.length = 40

  yield Effects.put({
    id: action.id,
    reservations: reservations.map(r =>
      r.savedColor ? { ...r, customColor: toColor(r.savedColor) } : r,
    ),
    type: ClientActions.SetInfoModalEvents,
  })
}

export default function*() {
  yield Effects.takeLatest(
    ClientActions.OpenReservationInfoModal,
    openInfoModal,
  )
}
